import useAddressSuggestions from '../../hooks/useAddressSuggestions'
import React, { useState, useEffect, useRef } from 'react'
import { TextField, Box, Autocomplete } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { config } from '../../config'
import requestStore from '../../stores/requestStore'

import logger from '../../utils/logger'
import i18nStore from '../../stores/i18nStore'

const AddressRequest = observer(({ onAddressChange, initialAddress = '' }) => {
	const [address, setAddress] = useState('')
	const addressLookup = useAddressSuggestions()
	const { suggestions: addressSuggestions, loading: isLoading, open, setOpen, error: addressError } = addressLookup
	const inputRef = useRef(null);

	useEffect(() => {
		setAddress(initialAddress || '')
	}, [initialAddress])

	const handleAddressChange = value => {
		setAddress(value)
		requestStore.resetAddressSelection()
		if (!value) requestStore.clearAddress()
		onAddressChange?.(value)
		addressLookup.search(value)
	}

	const handleSuggestionClick = suggestion => {
		requestStore.setAddress(suggestion.data)
		setAddress(suggestion.value);
		setOpen(false);
		addressLookup.clear();
		
		if (onAddressChange) {
			onAddressChange(suggestion.value)
		}
	}

	return (
		<Box sx={{ position: 'relative' }}>
			  {import.meta.env.VITE_SHOW_COMPONENT_NAME === 'true' && <div onClick={() => logger.log(address)}>% AddressRequest %</div>}

			<Autocomplete
				freeSolo
				filterOptions={options => options}
				open={open}
				onOpen={() => {
					if (addressSuggestions.length > 0 && address.length > 0) {
						setOpen(true);
					}
				}}
				onClose={() => setOpen(false)}
				options={addressSuggestions}
				getOptionLabel={(option) => typeof option === 'string' ? option : option.value}
				value={address}
				loading={isLoading}
				loadingText="Загрузка..."
				noOptionsText={address.length > 3 ? "Нет подходящих адресов" : "Введите больше символов"}
				onChange={(event, newValue) => {
					if (newValue && typeof newValue !== 'string') {
						handleSuggestionClick(newValue)
					} else if (newValue === null) {
						handleAddressChange('');
					} else if (typeof newValue === 'string') {
						setAddress(newValue);
						requestStore.resetAddressSelection();
						setOpen(false);
						if (onAddressChange) {
							onAddressChange(newValue);
						}
					}
				}}
				onInputChange={(event, newInputValue, reason) => {
					if (reason === 'input') {
						handleAddressChange(newInputValue)
					}
				}}
				renderInput={(params) => (
					<TextField
						{...params}
						ref={inputRef}
						label='Адрес'
						size='small'
						fullWidth
						sx={{ maxWidth: '500px' }}
						placeholder={`${i18nStore.currentCountry}  Выберите адрес из подсказок`}
						error={Boolean(addressError) || (address.length > 0 && !requestStore.isAddressSelected)}
						helperText={
							addressError || (address.length > 0 && !requestStore.isAddressSelected
								? 'Пожалуйста, выберите адрес из подсказок'
								: '')
						}
					/>
				)}
			/>
		</Box>
	)
})

export default AddressRequest
